/* eslint-disable */
/*
Array of universities
*/
export const universityObjArr = [// St. Petersburg universities
	{
		uniIndex: 0,
		name: 'Воспитательное общество благородных девиц',
		year: 1764,
		cityIndex: 0,
	}, {
		uniIndex: 0,
		name: 'Александровский институт',
		year: 1765,
		cityIndex: 0,
	}, {
		uniIndex: 0,
		name: 'Мариинский институт',
		year: 1797,
		cityIndex: 0,
	}, {
		uniIndex: 0,
		name: 'Училище Ордена св. Екатерины',
		year: 1798,
		cityIndex: 0,
	}, {
		uniIndex: 0,
		name: 'Павловский институт',
		year: 1798,
		cityIndex: 0,
	}, {
		uniIndex: 0,
		name: 'Елизаветинский институт',
		year: 1808,
		cityIndex: 0,
	}, {
		uniIndex: 0,
		name: 'Патриотический институт',
		year: 1813,
		cityIndex: 0,
	}, {
		uniIndex: 0,
		name: 'Училище св. Елены',
		year: 1820,
		cityIndex: 0,
	}, // Saratov unis
	{
		name: 'Саратовский институт',
		year: 1840,
		cityIndex: 1,
	}, // Tbilisi unis
	{
		name: 'Закавказский институт',
		year: 1840,
		cityIndex: 2,
	}, // Warsaw unis
	{
		name: 'Варшавский институт',
		year: 1840,
		cityIndex: 3,
	}, {
		name: 'Училище Ордена св. Екатерины',
		year: 1802,
		cityIndex: 5,
	}, {
		name: 'Александровский институт',
		year: 1804,
		cityIndex: 5,
	}, {
		name: 'Елизаветинский институт',
		year: 1825,
		cityIndex: 5,
	}, {
		name: 'Харьковский институт',
		year: 1812,
		cityIndex: 6,
	}, {
		name: 'Полтавский институт',
		year: 1819,
		cityIndex: 7,
	}, {
		name: 'Одесский институт',
		year: 1829,
		cityIndex: 8,
	}, {
		name: 'Оренбургский институт',
		year: 1832,
		cityIndex: 9,
	}, {
		name: 'Киевский институт',
		year: 1834,
		cityIndex: 10,
	},
	{
		name: 'Тамбовский институт',
		year: 1834,
		cityIndex: 11,
	},{
		name: 'Керченский институт',
		year: 1835,
		cityIndex: 12,
	},{
		name: 'Астраханский институт',
		year: 1837,
		cityIndex: 13,
	},{
		name: 'Белостокский институт',
		year: 1837,
		cityIndex: 14,
	}, {
		name: 'Казанский институт',
		year: 1837,
		cityIndex: 15,
	},{
		name: 'Иркутский институт',
		year: 1841,
		cityIndex: 17,
	},{
		name: 'Донской институт',
		year: 1852,
		cityIndex: 18,
	},{
		name: 'Нижегородский институт',
		year: 1852,
		cityIndex: 19,
	},{
		name: 'Кубанский институт',
		year: 1859,
		cityIndex: 20,
	},{

		name: 'Орловский институт',
		year: 1864,
		cityIndex: 4,
	}, // // CITYNAME unis
	// {
	// 	name: 'NAME',
	// 	year: YEAR,
	// 	cityIndex: 3
	// },
];

/* eslint-enable */
